import { LOGGED_OUT } from 'actions/types';
import { SET_SPENDING_INSIGHTS } from '../actions/types';
export const initialState = {};
const onboardingInsights = (state = initialState, action) => {
    switch (action.type) {
        case SET_SPENDING_INSIGHTS:
            return { ...state, spendingInsights: action.payload };
        case LOGGED_OUT:
            return initialState;
        default:
            return state;
    }
};
export default onboardingInsights;
